import React, { Fragment, Component } from 'react'
import * as Sentry from '@sentry/browser'

import { Error } from './views/components'

class ErrorBoundary extends Component {
	state = {
		showError: false,
	}

	componentDidCatch(err) {
		const { email } = this.props

		this.setState({ showError: true })

		// console.log('Error', err)

		// https://github.com/getsentry/sentry-javascript/issues/167
		// Sentry.captureException(err, {
		// 	extra: {
		// 		user: {
		// 			name: email,
		// 		},
		// 	},
		// })

		Sentry.withScope(scope => {
			scope.setUser({ email })
			Sentry.captureException(err)
		})
	}

	render() {
		const { showError } = this.state
		const { children } = this.props

		if (showError) {
			return <Error />
		}

		return <>{children}</>
	}
}

export default ErrorBoundary
